import { render, staticRenderFns } from "./SharedCampaignsTable.vue?vue&type=template&id=9d0e9b9a&scoped=true"
import script from "./SharedCampaignsTable.vue?vue&type=script&lang=js"
export * from "./SharedCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./SharedCampaignsTable.vue?vue&type=style&index=0&id=9d0e9b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0e9b9a",
  null
  
)

export default component.exports